import { Component, OnChanges, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";
import {StringUtils} from "../../../../utils/string-utils";

@Component({
    selector: 'app-vertical-sm-com-ratings',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './vertical-sm-com-ratings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './vertical-sm-com-ratings.component.css'
})
export class VerticalSmComRatingsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  readonly modelChange = output<void>();
  modelSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  cabinetHeightSelection!: GuruEntity;
  riserLocationSelection!: GuruEntity;
  unitVoltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  dischargeAirLocationSelection!: GuruEntity;
  straightDischargeAirSelection!: GuruEntity;
  riserStyleSelection!: GuruEntity;
  optionsSelection!: GuruEntity;
  knockOutSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.modelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USModel');
    this.sizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
    this.cabinetHeightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabHeight');
    this.riserLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserConn');
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.dischargeAirLocationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyAirOptions');
    this.straightDischargeAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSideSupplyAirOptions');
    this.riserStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRiserStyle');
    this.optionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabOptions');
    this.knockOutSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabKnockOut');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  modelChanged(entity: GuruEntity, newValue: string): void {
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.modelChange.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

  isHandArrangementImageAvailable(): boolean {
    return StringUtils.isNotBlank(this.imagePrefix()) && StringUtils.isNotBlank(this.handArrangementImagePath());
  }

}
